import { render, staticRenderFns } from "./StatisticsTable.vue?vue&type=template&id=f2ee401a&scoped=true&"
import script from "./StatisticsTable.vue?vue&type=script&lang=js&"
export * from "./StatisticsTable.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsTable.vue?vue&type=style&index=0&id=f2ee401a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2ee401a",
  null
  
)

export default component.exports